import { routeCreator } from '@adrias-online/steiner';
import _ from 'lodash';

import helper from 'helpers/steinerHelper';
import routeRegister from 'helpers/routeRegister';
import { selectors } from '../reducers/crmContatti';

const routes = helper.generateRoutes('crmContatti', selectors);

routes.list.list.breadcrumb = 'Rubrica';

routes.list.edit.breadcrumb = (state, ownProps) => {
    if (ownProps.match.params.id === 'create') {
        return {
            breadcrumbName: 'Crea nuovo contatto'
        };
    }

    const current = selectors.currentSelector(state);

    if (current && current.item) {
        const name = current.item.nome_referente
            ? current.item.nome_referente
            : current.item.nome_struttura;
        const zona =
            current.item.frazione_name && current.item.frazione_name !== '-'
                ? current.item.frazione_name
                : current.item.comune_name;

        return {
            breadcrumbName: `${name} - ${zona}`
        };
    }

    return {
        breadcrumbName: '...'
    };
};

const list = _.values(routes.list).map(route => ({
    ...route,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'crmContatti' */ `modules/crmContatti/${route.componentPath}`)
                .then(response => resolve(response.default));
        });
    },
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('crmContatti', routes.patterns);
routeRegister.addLinks('crmContatti', links);

export default list;